import { mallEntranceApi } from '../request'
import { apiPath } from '../api'

export const homegoods = {
  popupHomeCouponList: data =>
    mallEntranceApi.post(apiPath.popupHomeCouponList, data),
  getHomeGoodsDetail: data =>
    mallEntranceApi.post(apiPath.getHomeGoodsDetail, data),
  applyHomeGoodsDetail: data =>
    mallEntranceApi.post(apiPath.applyHomeGoodsDetail, data),
  getHomeCustomPage: data =>
    mallEntranceApi.post(apiPath.getHomeCustomPage, data),
  getHomeGoodsRank: data => mallEntranceApi.post(apiPath.getHomeGoodsRank, data)
}
